import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Alternatieve tekst voor deze afbeelding ontbreekt',
    noAnswers: "Geen antwoordoptie, klik op 'volgende' om door te gaan.",
    placeholder: 'Specificeer...',
    pleaseSelect: 'Selecteer...',
    rotateLandscape: 'Schakel de oriëntatievergrendeling uit op uw telefoon en draai naar landschap om door te gaan.',
    rotatePortrait: 'Draai uw telefoon van landschap naar portret om door te gaan.',
    ir: {
      selectWebCam: "Selecteer webcam (indien beschikbaar) of klik op 'Bladeren' om vanaf je apparaat te uploaden",
      noWebCam: 'Geen webcam gedetecteerd',
      accessCamUpload: 'CAMERA/UPLOADEN OPENEN',
      browse: 'BLADEREN',
      uploadPhoto: 'Upload een foto',
      camera: 'Webcamera ',
      instead: 'in plaats daarvan',
      capture: 'FOTO MAKEN',
      somethingWrong: 'Sorry, er ging iets mis. Probeer het later nog eens',
      couldntRead: 'Sorry, we konden de code niet lezen!',
      couldntProcess: 'Sorry, we konden je foto niet verwerken!',
      inValidCode: 'Please, submit the valid code', // !
      moveOn: 'Probeer het opnieuw of verzend je foto en ga verder',
      tryAgain: 'Probeer het opnieuw',
      dataReceived: 'Gegevens ontvangen!',
      enterManually: 'Probeer het opnieuw of voer de gegevens hieronder handmatig in',
      positionQR: 'Houd de QR-code voor je camera zodat deze in het rode kader past of upload hem vanaf je computer.',
      positionQRMobile: 'Plaats de QR-code voor uw camera of upload deze vanaf uw apparaat.',
      analyzing: 'Afbeelding wordt geanalyseerd, een moment geduld',
      submit: 'VERZENDEN',
      startOver: 'BEGIN OPNIEUW',
      allDone: 'KLAAR IS KEES!',
      cantAnalyze:
        'Opgelet - we hebben deze afbeelding niet kunnen weergeven. Probeer hem opnieuw in te dienen of kies een algemener afbeeldingsformaat (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Het spijt ons, we ondersteunen dit bestandsformaat niet. Upload een ondersteund afbeeldingstype (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Geen webcam gedetecteerd',
      uploadVideo: 'Upload een video', // ?
      skip: 'Overslaan?',
      accessCamUpload: 'CAMERA/UPLOADEN OPENEN',
      browse: 'BLADEREN',
      instead: 'in plaats daarvan',
      or: 'or', // !
      stopRecording: 'Stoppen met opnemen',
      willBeStopped: 'De opname stopt na <b>5 minuten<b/>',
      stopOnDone: 'Stop de opname als je klaar bent!',
      record: 'OPNEMEN',
      somethingWrong: 'Sorry, er ging iets mis. Probeer het later nog eens.',
      dataReceived: 'Gegevens ontvangen!',
      microphone: 'Microfoon',
      camera: 'Webcamera',
      selectMicrophone: 'Selecteer je microfoon', // ?
      selectCam: 'Selecteer je webcamera', // ?
      submit: 'VERZENDEN',
      upload: 'UPLOADEN',
      playback: 'AFSPELEN',
      stopPlayback: 'STOP PLAYBACK', // !
      startOver: 'BEGIN OPNIEUW',
      allDone: 'AKLAAR IS KEES!',
      alternativeRecordSpan:
        'Upload een videoclip vanaf je computer.<br/>Je kunt in plaats daarvan de video ook opnemen &nbsp;',
      alrenativeRecordHref: 'met een webcam',
      cantAnalyze:
        'Opgelet - we hebben deze video niet kunnen weergeven. Probeer hem opnieuw in te dienen of kies een algemener videoformaat (MP4, M4V, WEBPM)',
      wrongFormat:
        'Het spijt ons, we ondersteunen dit bestandsformaat niet. Upload een ondersteund videotype (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'KIEZEN',
      pleaseChoose: 'Maak een keuze',
      this: 'DIT',
      one: 'een',
      myChoice: 'MIJN KEUZE'
    },
    hm: {
      addComment: 'Plaats hieronder een reactie',
      commentMandatoryPlaceHolder: 'Voeg verplichte reactie toe...',
      commentOptionalPlaceHolder: 'Voeg optionele reactie toe...',
      dragPin: 'Sleep om te verplaatsen (lang klikken/tikken om nauwkeurig vast te prikken).',
      removePin: 'Sleep buiten de afbeelding om te verwijderen.',
      editComment: 'Klik/tik op speld om reactie te bewerken.',
      addPin: 'Versleep de speld uit het onderstaande paneel en plaats hem op een plek naar keuze op de afbeelding.',
      addPins: 'Versleep de spelden uit het onderstaande paneel en plaats ze op een plek naar keuze op de afbeelding.',
      leavePins: (minPoints, maxPoints) =>
        `Laat minstens ${minPoints}, maar niet meer dan ${maxPoints} spelden van elk type achter.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Laat tenminste ${minPoints} maar niet meer dan ${maxPoints} pins van welke soort dan ook achter.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Laat minstens  ${minPoints}, maar niet meer dan ${maxPoints} spelden achter.`,
      leavePinsWithOff: maxPoints =>
        `Laat niet meer dan ${maxPoints} spelden van elk type achter of klik op 'volgende' om over te slaan.`,
      leavePinsWithOffAny: maxPoints =>
        `Laat niet meer dan ${maxPoints} pins van welke soort dan ook achter of klik op Volgende om dit over te slaan.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Laat niet meer dan ${maxPoints} spelden achter of klik op 'volgende' om over te slaan.`,
      leavePinWithOff: `Laat niet meer dan 1 speld van elk type achter of klik op 'volgende' om over te slaan.`,
      leavePinWithOffAny: `Laat niet meer dan 1 pin achter of klik op Volgende om dit over te slaan.`,
      leavePinPerPageWithOff: "Laat niet meer dan 1 speld achter of klik op 'volgende' om over te slaan.",
      leaveExactlyPin: `Laat 1 speld van elk type achter.`,
      leaveExactlyPinAny: `Laat 1 pin van welke soort dan ook achter.`,
      leaveExactlyPinPerPage: 'Laat 1 speld achter.',
      leaveExactlyPins: maxPoints => `Laat ${maxPoints} spelden van elk type achter.`,
      leaveExactlyPinsAny: maxPoints => `Laat ${maxPoints} pins van welke soort dan ook achter.`,
      leaveExactlyPinsPerPage: maxPoints => `Laat ${maxPoints} spelden achter.`,
      leaveComment: 'Typ onder de afbeelding om een reactie achter te laten.',
      noAnswers: "Geen antwoordoptie, klik op 'volgende' om door te gaan.",
      outOfPins: 'je hebt geen spelden meer',
      pinsBehavior: 'Als je over het beeld gaat zie je plaatsen die gemarkeerd worden met een enkele speldenknop.',
      clusters: 'Je kunt alleen spelden plaatsen op deze gemarkeerde plaatsen.',
      contentAware: 'Je kunt binnen of buiten de gemarkeerde plaatsen spelden neerzetten.'
    },
    mp: {
      expand_note: 'Beweeg de muisaanwijzer over of klik op de afbeeldingen(en) om te vergroten',
      rb_note: rows => `Kies${rows ? ' hieronder' : ''} 1 antwoord per onderdeel:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Kies${rows ? ' hieronder' : ''} ${min !== 1 ? '' : 'slechts'} ${min} ${
            min !== 1 ? 'antwoorden' : 'antwoord'
          } per onderdeel:`
        } else if (min > 0 && max < 5000) {
          return `Selecteer ten minste ${min} ${
            min !== 1 ? 'antwoorden' : 'antwoord'
          } maar niet meer dan ${max} per item${rows ? ' hieronder' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Selecteer ten minste ${min} ${min !== 1 ? 'antwoorden' : 'antwoord'} per item${
            rows ? ' hieronder' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Selecteer niet meer dan ${max} ${max !== 1 ? 'antwoorden' : 'antwoord'} per item${
            rows ? ' hieronder' : ''
          }:`
        } else {
          return 'Vink alles aan wat van toepassing is:'
        }
      }
    },
    sh: {
      note: 'Klik op een product om in te zoomen en toe te voegen aan uw virtuele winkelwagentje als u het in de winkel zou kopen',
      amazonNote: 'Klik op een product om in te zoomen en toe te voegen aan je virtuele winkelwagen.',
      fullCart: 'Uw winkelwagentje is vol!',
      qty: 'AANTAL',
      addToCart: 'TOEVOEGEN AAN WINKELWAGENTJE',
      deleteFromCart: 'VERWIJDEREN',
      next: 'VOLGENDE',
      emptyCard: 'Uw winkelwagentje is leeg',
      each: 'elk',
      items: 'artikelen',
      total: 'Winkelwagentje',
      clearCart: 'Winkelwagentje legen',
      backToStore: 'Terug naar de winkel',
      na: 'Geen van bovenstaande',
      maxCartCountError: max => `Lütfen ürün sepetinize en fazla ${max} ürün ekleyin `,
      scrollError: `Scrol volledig naar links en rechts om verder te gaan met de enquête.`,
      maxSpentError: max => `Lütfen ${max} tutarından fazla harcamayın. `,
      maxProductCountError: max => `Lütfen her ürün için sepetinize en fazla ${max} adet ekleyin. `
    },
    rb: {
      note: 'Selecteer slechts 1 item:'
    },
    vo: {
      note: 'Bekijk de video helemaal\n'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Vink alles aan wat van toepassing is:'
        } else if (min === max) {
          return `Kies hieronder ${min !== 1 ? '' : 'slechts'} ${min} antwoord${min !== 1 ? 'en' : ''} per onderdeel:`
        } else if (min > 0 && max < 5000) {
          return `Selecteer ten minste ${min} antwoord${
            min !== 1 ? 'en' : ''
          } maar niet meer dan ${max} per item hieronder:`
        } else if (5000 === max && min > 0) {
          return `Selecteer ten minste ${min} antwoord${min !== 1 ? 'en' : ''} per item hieronder:`
        } else if (0 === min && max < 5000) {
          return `Selecteer niet meer dan ${max} antwoord${max !== 1 ? 'en' : ''} per item hieronder:`
        } else {
          return 'Vink alles aan wat van toepassing is:'
        }
      }
    },
    oe: {
      na: 'Niet toepasbaar',
      note: (min, max, optional) => {
        if (min === max) {
          return `Typ ${1 !== min ? '' : 'exact'} ${min} teken${1 !== min ? 's' : ''}${optional ? ' (optioneel)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Typ minstens ${min} teken${1 !== min ? 's' : ''} maar niet meer dan ${max}${
            optional ? ' (optioneel)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Typ minstens ${min} teken${1 !== min ? 's' : ''}${optional ? ' (optioneel)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Typ niet meer dan ${max} teken${1 !== min ? 's' : ''}${optional ? ' (optioneel)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Vul de volgende velden in:'
    },
    mx: {
      note: 'Verplaats de gemarkeerde schuifregelaars om door te gaan',
      dragSlider: 'Versleep naar links of rechts om te antwoorden'
    },
    psc: {
      dragLeftRight: 'Versleep naar links of rechts om te antwoorden'
    },
    ps: {
      note: (value, remaining) => `Verdeel${remaining ? ' de resterende' : ''} ${value} over de onderstaande items`,
      allDone: `Klaar is Kees`,
      total: `Total:`, // !
      dragSlider: 'Versleep naar links of rechts om te antwoorden'
    },
    cx: {
      note: 'Open de dropbox en begin je antwoord te typen om automatisch te scrollen of kies het handmatig'
    },
    ro: {
      note: 'Sleep omhoog of omlaag om opnieuw te ordenen:'
    },
    md: {
      note1: 'Klik/tik op het item van je <b>eerste keuze</b>.<br/> Klik/tik opnieuw om de keuze te wissen.',
      note2: 'Klik/tik op het item van je <b>laatste keuze</b>.<br/> Klik/tik opnieuw om de keuze te wissen.',
      note3:
        'Bedankt! Ga verder naar de volgende vraag of klik/tik op een niet-geselecteerd item om opnieuw te beginnen.'
    },
    aro: {
      note: 'Kies uit elk paar één item:'
    },
    wd: {
      note: 'Zorg ervoor dat elke volgende waarde groter is dan de vorige.'
    },
    emd: {
      note: 'Bekijk de video helemaal',
      noAnswers: "Geen antwoordoptie, klik op 'volgende' om door te gaan.",
      start: 'Klik en houd ingedrukt om te starten',
      resume: 'Klik en houd ingedrukt om door te gaan',
      continue: "U bent klaar! <br />Klik op 'volgende' om door te gaan",
      continueMobile: 'Je bent klaar! <br /> Klik HIER om verder te gaan',
      training: {
        session: 'trainingssessie',
        note: 'Maak de training af',
        moveLeft: 'Sleep de schijf helemaal naar links',
        moveBottom: 'Sleep de schijf helemaal naar beneden',
        moveRight: 'Sleep de schijf nu helemaal naar rechts',
        moveTop: 'Sleep de schijf nu helemaal naar boven',
        success: 'Goed gedaan!'
      }
    },
    sft: {
      noAnswers: "Geen antwoordoptie, klik op 'volgende' om door te gaan.",
      note: 'Antwoord alstublieft zo snel mogelijk met het antwoord dat intuïtief goed aanvoelt',
      finish: 'U bent helemaal klaar! <br />Klik op Volgende om door te gaan.',
      training: {
        start:
          '<p>Deze vraag zal u snel verschillende woorden laten zien en vereist uw concentratie. ' +
          'U dient snel te reageren om te antwoorden.</p> <p>Klaar om te oefenen?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tik op "{buttonLeft}"`
            : (mouse ? `Klik op "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Druk op de "{keyBtnLeft}"-toets` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tik op "{buttonRight}"`
            : (mouse ? `Klik op "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Druk op de "{keyBtnRight}"-toets` : ''),
        fail: () => 'Te traag',
        success: () => 'Geweldig!',
        finish: () =>
          '<p><strong> Uitstekend!</strong></p><p>Zorg ervoor dat u de komende <br />' +
          '2-3 minuten niet wordt afgeleid. </p><p>Klik op Volgende om te starten als u er klaar voor bent.</p>'
      },
      buttons: {
        start: 'Aan de slag',
        yesno: {
          left: 'Ja',
          right: 'Nee'
        },
        matches: {
          left: 'Match',
          right: 'Geen match'
        },
        fits: {
          left: 'Past',
          right: 'Past niet'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
